var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import useTaroBaseEvents from '../_util/hooks/useTaroBaseEvents';
const Text = (_a, ref) => {
    var { className, space = false, selectable = false, children } = _a, rest = __rest(_a, ["className", "space", "selectable", "children"]);
    const props = useTaroBaseEvents(rest);
    if (typeof children === 'string') {
        if (space === 'nbsp') {
            children = children.replace(/ /g, ' ');
        }
        else if (space === 'ensp') {
            children = children.replace(/ /g, ' ');
        }
        else if (space === 'emsp') {
            children = children.replace(/ /g, ' ');
        }
    }
    return (_jsx("span", Object.assign({ ref: ref, className: classNames('taro-text', { 'taro-text_selectable': selectable }, className) }, props, { children: children })));
};
export default forwardRef(Text);
